/**
 * Setup pills → the cart form's variant id.
 *
 * The pills are labels, not the form control: the form needs a variant id and a shopper
 * needs words. Changing a pill writes the id into the hidden input and fires `change` on
 * both the input and the form, which is what the Timesact embed listens for — it debounces
 * on the form and re-reads the current variant, then re-renders badge, button, message and
 * payment terms. Without the dispatch the page would look switched while the app kept
 * rendering the old setup.
 */
if (!window.__xbBound) {
  window.__xbBound = true;
  document.addEventListener("change", (event) => {
  const radio = event.target.closest('input[type="radio"][name^="option-setup-"]');
  if (!radio) return;
  const form = radio.closest("form");
  const hidden = form?.querySelector("[data-xb-id]");
  if (!hidden) return;
  hidden.value = radio.value;
  hidden.dispatchEvent(new Event("change", { bubbles: true }));
  form.dispatchEvent(new Event("change", { bubbles: true }));
  radio.closest(".xb-pills")?.querySelectorAll(".xb-pill").forEach((p) => p.classList.remove("is-on"));
  radio.closest(".xb-pill")?.classList.add("is-on");
})
}
